import { geti18nText, NyDataTable, NySession } from '@nybble/nyreact';
import React from 'react';
import { CONSTANTS_REQ, DeviceCategoryType } from '../../utils/Constants';
import Device from '../device';

const Lights = () => {
    return (
        <>
            <Device type={DeviceCategoryType.LIGHTS}></Device>
        </>
    );
};

export default Lights;
